<div style="background-color: #dedede;line-height: 0px;">
    <ol class="breadcrumb breadcrumb_cstm" style="background: transparent;
              font-size: 12px;margin-bottom: 0 !important;">
        <li class="breadcrumb-item item" *ngFor="let item of breadcrumbsArray; let i = index">
            <a (click)="goToPageLink(item)">
                {{ item }}
            </a>
        </li>
    </ol>
</div>


<mat-toolbar>
    <h6 class="show-title">Add Group</h6>
    <button class="more-btn-custom" mat-raised-button (click)="addDevice()">
        <i class="material-icons icon-layout-custom">add_circle</i>
        &nbsp;
        Add New
    </button>
</mat-toolbar>

<div fxLayoutAlign="center center" class="form_outer" fxLayout="column" style="padding: 16px;">

    <mat-form-field class="example-full-width" floatLabel="always">
        <input matInput placeholder="Site name" disabled value="Room 123">
        <!-- <mat-placeholder class="placeholder">Site name</mat-placeholder> -->
    </mat-form-field>


    <mat-form-field class="example-full-width" floatLabel="always">
        <input placeholder="Group name" matInput>
        <!-- <mat-placeholder class="placeholder">Group name</mat-placeholder> -->
    </mat-form-field>


    <mat-form-field class="example-full-width" floatLabel="always">
        <input placeholder="Group description" matInput>
        <!-- <mat-placeholder class="placeholder">Group description</mat-placeholder> -->
    </mat-form-field>

    <mat-form-field aria-placeholder="Associate users" class="example-full-width" floatLabel="always">
        <!-- <mat-select placeholder="Associate users"> -->
            <mat-option>
                Option 1
            </mat-option>
            <mat-option>
                Option 2
            </mat-option>
        <!-- </mat-select> -->
    </mat-form-field>


    <mat-form-field class="example-full-width" floatLabel="always">
        <mat-select placeholder="Associate assets">
            <mat-option>
                Option 1
            </mat-option>
            <mat-option>
                Option 2
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="btn-box">
        <button mat-raised-button style="border-radius: 50px;" (click)="saveDevice()">Save</button>
    </div>


</div>